import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
	faComment,
	faCommentCheck,
	faCommentDots,
	faCommentExclamation
} from '@awesome.me/kit-bde9a98016/icons/sharp/solid';
import { AhsTranslationService } from '@nx-ahs/base-translate';
import { ConversationModel } from '../../models/conversation.model';

//class subjectDescription {
//    codename: string;
//    translatedDescription: string;
//}

@Component({
	selector: 'message-panel',
	templateUrl: './message-panel.component.html',
	styleUrls: ['./message-panel.component.scss'],
	standalone: false
})
export class MessagePanelComponent implements OnInit {
	public faIcons = {
		faComment: faComment,
		faCommentCheck: faCommentCheck,
		faCommentDots: faCommentDots,
		faCommentExclamation: faCommentExclamation
	};

	@Input() conversations: ConversationModel[] = [];
	@Input() selectedId: number;
	@Input() showDisplayName: boolean = false;
	@Output() selectedConversationId: EventEmitter<any> = new EventEmitter<any>();

	//public subjectDescriptions: subjectDescription[] = [];

	constructor(private translate: AhsTranslationService) {}

	ngOnInit() {}

	public goToMessage(id: number) {
		this.selectedId = id;
		this.selectedConversationId.emit(id);
	}
}
